import { render, staticRenderFns } from "./subordinate_branch.vue?vue&type=template&id=763bdce4&scoped=true&"
import script from "./subordinate_branch.vue?vue&type=script&lang=js&"
export * from "./subordinate_branch.vue?vue&type=script&lang=js&"
import style0 from "./subordinate_branch.vue?vue&type=style&index=0&id=763bdce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763bdce4",
  null
  
)

export default component.exports